import { FC, ReactNode } from 'react';
import React from 'react';

import styles from './Layout.module.scss';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => (
  <main
    className={styles.layout}
    aria-live="assertive"
    aria-atomic={true}
    aria-relevant="all"
  >
    {children}
  </main>
);
